/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_percentile.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts a multivalued field into a single valued field containing the value at which a certain percentage of observed values occur.
 *
 * @example
 * ROW values = [5, 5, 10, 12, 5000]
 * | EVAL p50 = MV_PERCENTILE(values, 50), median = MV_MEDIAN(values)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'mv_percentile',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
        {
          name: 'percentile',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
